/* eslint-disable quotes */
import { h } from 'vue';

const body = `<h4>Save reduced version of STL model to file (BETA!)</h4>

<p>Subsample and save the STL in a new file. </p>

<p>Give a factor that defines the resolution reduction. A smaller factor results in a smaller number of output triangles.</p>`;

export default function CompressSTLTooltip() {
    return h('div', { innerHTML: body });
}
